import React from 'react';
import Select from 'react-select';
import useFetchDatav2 from '../hooks/useFetchDatav2';

function GroupLabel({ data }) {
  if (!data) return null;
  return (
    <div className="flex justify-between items-center py-1">
      <span className="font-semibold text-gray-700">{data.label}</span>
      <span className="bg-gray-200 text-gray-600 px-2 py-0.5 rounded-full text-xs">
        {data.options?.length || 0}
      </span>
    </div>
  );
}

function CohortPrefixSelector({ value, onChange, cohortType, disabled }) {
  const { data, isLoading } = useFetchDatav2(
    ['cohort-prefixes', cohortType],
    '/cohorts/prefixes',
    { params: { cohort_type: cohortType || '', active_only: 'true' } },
    null,
    true
  );

  const prefixOptions = React.useMemo(() => {
    if (!data?.data?.prefixes) return [];

    const grouped = {};
    data.data.prefixes.forEach((prefix) => {
      const type = prefix.cohort_type || 'Other';
      if (!grouped[type]) {
        grouped[type] = [];
      }
      grouped[type].push({
        value: prefix.id,
        label: `${prefix.code} - ${prefix.name}`,
        code: prefix.code,
        cohortType: prefix.cohort_type,
      });
    });

    return Object.entries(grouped).map(([type, options]) => ({
      label: type,
      options,
    }));
  }, [data]);

  const selectedOption = React.useMemo(() => {
    if (!value || !data?.data?.prefixes) return null;
    const prefix = data.data.prefixes.find((p) => p.id === value);
    if (!prefix) return null;
    return {
      value: prefix.id,
      label: `${prefix.code} - ${prefix.name}`,
      code: prefix.code,
      cohortType: prefix.cohort_type,
    };
  }, [value, data]);

  return (
    <Select
      value={selectedOption}
      onChange={(option) => onChange(option?.value || '')}
      options={prefixOptions}
      isLoading={isLoading}
      isDisabled={disabled}
      isClearable
      placeholder="Select Student ID Prefix"
      className="react-dropdown"
      classNamePrefix="dropdown"
      formatGroupLabel={GroupLabel}
    />
  );
}

export default CohortPrefixSelector;
